import React from "react";
import BqnContext from "common/BqnContext";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import { useContext } from "react";
import styled from "styled-components";

const StatusResultLayout = styled.div`
  .fact {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    color: #777;
    .field {
      text-align: left;
    }
    .value {
      text-align: left;
    }
    .field,
    .value {
      font-size: 1em;
      flex: 3ch 1 0;
    }
    &.warning {
      color: red;
    }
  }
`;

export function ClusterStatus() {
  const { bqnId, clusterStatus } = useContext(BqnContext);
  return (
    <StatusResultLayout>
      <ColumnsGrid
        columns={1}
        maxWidth="3cm"
        gap="2.5px"
        minWidth="3cm"
        rowGap="0"
      >
        <div className="fact">
          <span className="field">Cluster mode:</span>
          <span className="value">{clusterStatus.mode}</span>
        </div>
        {bqnId === 'all' ? null :
          <div className="fact">
            <span className="field">BQN ID:</span>
            <span className="value">{bqnId}</span>
          </div>
        }

        {clusterStatus.mode === "cluster" && (
          <>
            <div className="fact">
              <span className="field">State:</span>
              <span className="value">{clusterStatus.state}</span>
            </div>
            <div className="fact">
              <span className="field">Status:</span>
              <span className="value">{clusterStatus.status}</span>
            </div>
            <div className="fact">
              <span className="field">Total BQNs:</span>
              <span className="value">{clusterStatus.total}</span>
            </div>

            <div className="fact">
              <span className="field">Online BQNs:</span>
              <span className="value">{clusterStatus.online}</span>
            </div>
            <div className="fact">
              <span className="field">Primary BQN:</span>
              <span className="value">{clusterStatus.primary}</span>
            </div>
            <div className="fact">
              <span className="field">Minimum BQN:</span>
              <span className="value">{clusterStatus.minimum}</span>
            </div>
            <div className="fact">
              <span className="field">Maximum BQN:</span>
              <span className="value">{clusterStatus.maximum}</span>
            </div>
          </>
        )}
      </ColumnsGrid>
    </StatusResultLayout>
  );
}
